module.exports = __webpack_public_path__ + "img/i-close-w.7b41dc88.svg";